import { render, staticRenderFns } from "./coSeller.vue?vue&type=template&id=f50f7956&scoped=true"
import script from "./coSeller.vue?vue&type=script&lang=js"
export * from "./coSeller.vue?vue&type=script&lang=js"
import style0 from "./coSeller.vue?vue&type=style&index=0&id=f50f7956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50f7956",
  null
  
)

export default component.exports